import styled from '@emotion/styled';

export const DateRangeColumns = styled('div', { label: 'DateRangeColumns' })`
    margin-right: 16px;
    display: inline-flex;
`;

export const DateColumnsRow = styled('div', { label: 'DateColumnsRow' })`
    position: relative;
    display: inline-flex;
    align-items: center;
    width: 100%;
`;

export const SearchBtn = styled('button', { label: 'SearchBtn' })`
    padding: 8px 12px;
    height: 32px;
    border: solid 1px #bbb;
    font-size: 14px;
    line-height: 1;
    cursor: pointer;
`;

export const SelectDate = styled('select', { label: 'SelectDate' })`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 12px 0 0 8px;
    border: none;
    appearance: none;
    font-size: 12px;
    line-height: 1;
    z-index: 2;
    background-color: transparent;
`;

export const SelectDateWrapper = styled('div', { label: 'SelectDateWrapper' })`
    position: relative;
    width: 138px;
    height: 32px;
    padding: 3px 0 0 8px;
    box-shadow: inset 0 1px 3px 0 rgba(0,0,0,0.5);
    border: solid 1px #d7d7d7;
    font-size: 10px;
    color: #acacac;
    line-height: 1;
    &::after {
        position: absolute;
        top: 0;
        bottom: 0;
        right: 8px;
        margin: auto;
        content: '';
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 4px 4px 0 4px;
        border-color: #2b2b2b transparent transparent transparent;
        z-index: 1;
        pointer-events: none;
    }
`;

interface PropsType {
    isValid: boolean;
}

export const DateInput = styled('div', { label: 'DateInput' })`
    margin: 5px 0;
`;

export const DatePickerWrapper = styled('div', { label: 'DatePickerWrapper' })<PropsType>`
    position: relative;
    .react-datepicker__input-container {
        input {
            border: ${({ isValid }): string => isValid ? 'solid 1px #3dcb35' : '1px solid  #ccc'};
            box-shadow: none;
        }
    }
    span[role="alert"] {
        display: none;
    }
`;

export const DatePickerLabel = styled('span', { label: 'DatePickerLabel' })`
    color: #bbb;
    font-size: 10px;
    position: absolute;
    left: 10px;
    top: -2px;
    z-index: 1;
`;
